import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ShipmentEditComponent } from '../../shipment-edit/shipment-edit.component';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { CommonModule, Location } from '@angular/common';
import { log } from 'console';
import { AttatchmentModalComponent } from 'src/app/shared/components/attatchment-modal/attatchment-modal.component';
import { TranslationService, I18nModule } from '@spartacus/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ShipmentVmsEblBlComponent } from '../../shipment-vms-ebl-bl/shipment-vms-ebl-bl.component';
import { ToastService } from 'src/app/core/services/toaster.service';
import { CustomProductsService } from '../../../custom-products/custom-products.service';
import { pairwise } from 'rxjs';
import { FileUploadModule } from 'ng2-file-upload';
import { AttachInvoiceComponent } from '../../attach-invoice/attach-invoice.component';
import { PortInvoiceComponent } from '../../port-invoice/port-invoice.component';
@Component({
    selector: 'app-shipment-vms-details',
    imports: [RouterModule, CommonModule, I18nModule, SharedModule, FileUploadModule],
    templateUrl: './shipment-vms-details.component.html',
    styleUrl: './shipment-vms-details.component.scss'
})
export class ShipmentVmsDetailsComponent implements OnInit {

  shipmentDetail: any;
  id: any;
  shipData: any = {};
  passingArray: any = {};
  ETA: any;
  ETA_time: any;
  ETB: any;
  ETB_time: any;
  ETSD: any;
  ETSD_time: any;
  ETCD: any;
  ETCD_time: any;
  state: any;
  title: any = '';
  navigationData: string = '';
  pathTitle: string = '';
  enableLoader: boolean;
  fromScreenQueryParam: any;
  openPopup:boolean=true;
  isAgentInvoiceActive: string = 'false';
  section:any;
  constructor(private activatedRoute: ActivatedRoute, private location: Location, 
    private translation: TranslationService, public modalService: NgbModal, private router: Router,
     private route: ActivatedRoute, private customProductService:CustomProductsService,
    private customprofile: CustomProfileService, private toastrservice: ToastService) {
   
  }
  ngOnInit(): void {
     this.customProductService.returnAgentInvoiceActive().subscribe(res=>{
      this.isAgentInvoiceActive = res;
   })
    // const navigation = this.router.getCurrentNavigation();
    // this.state = navigation.extras.state as { nominationItemNumber: string, nominationKey: string };
     this.id = this.route.snapshot.paramMap.get('id');
    this.passingArray = {
      nominationItemNumber:  this.route.snapshot.queryParams.nominationItemNumber,
      nominationKey:  this.route.snapshot.queryParams.nominationKey,
      nominationNumber: this.id,
    }
    this.fromScreenQueryParam = this.route.snapshot.queryParams.fromscreen;
    console.log(this.passingArray);
     if(this.router.url.includes('portside')){
      this.section = 'portside';
     } else if(this.router.url.includes('bondedwarehouse')){
      this.section = 'bondedwarehouse';
     }
    this.translation
      .translate('breadcrumb.shipmentListDetail.pageTitle')
      .subscribe(res => {
        this.title = res;
      });
    this.translation
      .translate('breadcrumb.shipmentListDetail.pageDetailTitle')
      .subscribe(res => {
        this.pathTitle = res;
      });
    this.translation
      .translate('breadcrumb.shipmentListDetail.breadcrumb')
      .subscribe(res => {
        this.navigationData = res;
        console.log('navigation', this.navigationData);

      });
    this.getShipmentDetails();
    this.customProductService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
      this.enableLoader = true;
      if (current != null) {
        if (previous !== current) {
          this.openPopup=false;
          this.getShipmentDetails();
        }
      }
    })

  }
  getShipmentDetails() {
    this.enableLoader = true;
    let toastshown =false;
    this.customprofile.shipmentDetail(this.passingArray).subscribe((response: any) => {
      this.enableLoader = false;
      if (response) {
        this.shipData = response;
        console.log(this.shipData);
        if (this.shipData.eta) {
          let splitETA = this.shipData.eta.split('-');
          this.ETA = splitETA[0];
          this.ETA_time = splitETA[1];

        }
        if (this.shipData.etb) {
          let splitETB = this.shipData.etb.split('-');
          this.ETB = splitETB[0];
          this.ETB_time = splitETB[1];
        }
        if (this.shipData.etsd) {
          let splitETSD = this.shipData.etsd.split('-');
          this.ETSD = splitETSD[0];
          this.ETSD_time = splitETSD[1];
        }
        if (this.shipData.etcd) {
          let splitETCD = this.shipData.etcd.split('-');
          this.ETCD = splitETCD[0];
          this.ETCD_time = splitETCD[1];
        }
        if (this.fromScreenQueryParam == 'updateInfo' && this.openPopup==true) {
          this.openEdit();
        }
      }
      else {
        // this.toastrservice.show('No data returned from Commerce, please contact support team')
        this.translation.translate('shipment.emptyerrormessage').subscribe(res=>{   
          if(!toastshown){
            this.toastrservice.show(res);
            toastshown=true;
          }
        })
      }
    }, err => {
      this.enableLoader = false;
      // this.toastrservice.show('API error occurred while fetching shipment details, please contact support team')
      this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{   
        if(!toastshown){
          this.toastrservice.show(res);
          toastshown=true;
        }
      })
    })
  }
  goToAttachment(shipData) {
    const ModalRef = this.modalService.open(AttatchmentModalComponent, { centered: true, size: 'lg' });
    ModalRef.componentInstance.shipData = this.shipData;
    ModalRef.componentInstance.fromComponent = 'shipmentdetails';
    ModalRef.result.then(res => {
      if (res == 'success') {
        this.getShipmentDetails();
      }
    })

  }

  openEdit() {
    const ModalRef = this.modalService.open(ShipmentEditComponent, { centered: true, size: 'md' });
    ModalRef.componentInstance.shipData = this.shipData;
    ModalRef.componentInstance.fromscreen = 'details'
  }
  backtoshipment() {
   this.router.navigate(['/shipmentvms/shipmentvmslist/' + this.section],{queryParams:{from:'details'}});
  }
  openEditEBL(popup_to_open) {
    const modalRef = this.modalService.open(ShipmentVmsEblBlComponent, { centered: true, size: 'md' });
    modalRef.componentInstance.shipData = this.shipData;
    modalRef.componentInstance.modalToOpen = popup_to_open;
    modalRef.result.then(res=>{
      if(res=='saved'){
        this.getShipmentDetails();
      }
    })
  }
      openInvoices(data: any){
      const modalref = this.modalService.open(AttachInvoiceComponent, {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
      });
      modalref.componentInstance.display='invoices';
      modalref.componentInstance.batchData = data;
        modalref.componentInstance.useCaseType = 'CARGOARRIVALINVOICE_UC3';
    }
 openPortInvoices(data: any){
    const modalref = this.modalService.open(PortInvoiceComponent, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
    });
    modalref.componentInstance.display='portInvoices';
    modalref.componentInstance.batchData = data;
   }
    
}
